export enum ExamNoticeType {
  PROCESS = 'process',
  WRITTEN = 'written',
  SKILL = 'skill',
  ROAD = 'road',
}
